import React from 'react';
import { connect } from 'react-redux'

import "react-responsive-carousel/lib/styles/carousel.min.css";

import CardInfo from './cardInfo.js'
import CloseButton from './closeButton.js'
import EmptyCardsGroupHeader from './emptyCardsGroupHeader.js';
import SendNewButton from './sendNewButton.js';

class EmptyCardsGroupBody extends React.Component{

    render(){
        let customcardId = this.props.cardsGroup.attributes.customcard_id
        let customcard = null
        if (customcardId) {
            customcard = this.props.projectData.customcards[customcardId.toString()]
        }

        return (
            <div>
                <div className="empty-card-layout card-transparent">
                    <div className="card-section card-color rounded-border m-3">
                        <CloseButton/>
                        <EmptyCardsGroupHeader cardsGroup={this.props.cardsGroup} customcard={customcard}/>
                         { this.props.userRole.add_card ? 
                            <SendNewButton cardsGroup={this.props.cardsGroup} /> : <div></div>
                         }
                        <CardInfo cardsGroup={this.props.cardsGroup}/>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        popup       : state.popup,
        userRole    : state.userRole
    }
}

export default connect(mapStateToProps)(EmptyCardsGroupBody)